module.exports = __webpack_public_path__ + "img/delivery.a65066d9.svg";